import { type UseQueryResult, useQuery } from 'react-query';
import { PsuElectionWindowConfigurationService } from '../../services/wealthlane-award-settlement-services';
import { MyHoldingsSharedService, PsuAwardService } from '../../services/wealthlane-award-services';

const useGetPsuAwardPerformanceRuleDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  awardId: string
): any => {
  const psuAwardPerformanceRuleDetails = useQuery(
    ['getPsuAwardPerformanceRuleDetails', awardId],
    async () => {
      if (awardId) {
        return await handleRequest(
          MyHoldingsSharedService.getApiAwardApiAppMyHoldingsPerformanceRuleDetail(awardId)
        );
      }
    }
  );
  return psuAwardPerformanceRuleDetails;
};

export default useGetPsuAwardPerformanceRuleDetails;
